import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance_create_for_single_employee = get_axios_instance(api_variables.SERVICE_CREATE_RUN_FBP_PROCESS);
var axios_instance_create_for_all_employee = get_axios_instance(api_variables.SERVICE_CREATE_RUN_FBP_PROCESS_FOR_ALL);
var axios_instance_get = get_axios_instance(api_variables.SERVICE_CREATE_RUN_FBP_GET);

const _pk_name = "id";

const state = {
    data: [],
    employeeData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};
const getters = {

}
const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setEmployeeData: (state, payload) => {
        if (payload) {
            state.employeeData = payload;
        }
        //console.log('fetched exits', state.employeeData)
    },
    updateEmployeeFBPClaimsById: (state, payload) => {
        //console.log(payload);
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/payroll/fbpprocessMonth/fetchAll] Calling API...",payload);
        try {
            //commit("setFetching", true);
            let res = await axios_instance_get.get(``, {
                params: {
                    le_id: payload.le_id,
                    month: payload.month,     
                    year: payload.year
                  }
              });

            //commit("setFetching", false);
            //console.log("[state/payroll/fbpprocessMonth/fetchAll] res: ", res);
            if (res.status == 200) {
                //commit("set", res.data.payload.data);
            }
            return res;
        } catch(error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },
    async createForSingleEmp({ commit }, payload) {
        //console.log("axios_instance_create_for_single_employee Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_create_for_single_employee.post('/', payload);
            commit("setSaving", false);
            //console.log("axios_instance_create_for_single_employee res: ", res);
            if (res.status == 200) {
                //commit("addEmployee", payload);
            }
            return res;
        } catch(err) {
            throw errorHandler(err.response);
        }
    },

    async createForAllEmp({ commit }, payload) {
        //console.log("axios_instance_create_for_all_employee Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_create_for_all_employee.post('/', payload);
            commit("setSaving", false);
            //console.log("axios_instance_create_for_all_employee res: ", res);
            if (res.status == 200) {
                //commit("addEmployee", payload);
            }
            return res;
        } catch (err){
            throw errorHandler(err.response);
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}